import { BraintreeOptions, BraintreeResult } from './src/ExpoBraintree.types';

// Venmo is always available on web
export function isVenmoAvailable(..._props: unknown[]): boolean {
  return true;
}

export async function getPayPalNonce(_input: BraintreeOptions): Promise<BraintreeResult> {
  throw new Error('getPayPalNonce is not implemented for web');
}

export async function getVenmoNonce(_input: BraintreeOptions): Promise<BraintreeResult> {
  throw new Error('getVenmoNonce is not implemented for web');
}
